import React from 'react';
import Svg, { Path } from 'react-native-svg';
var SvgComponent = function SvgComponent() {
  return /*#__PURE__*/React.createElement(Svg, {
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none"
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0294 1.53039L5.88296 7.67683C5.39481 8.16499 4.60335 8.16499 4.1152 7.67683L0.46875 4.03039L1.52941 2.96973L4.99908 6.4394L10.9688 0.469727L12.0294 1.53039Z",
    fill: "white"
  }));
};
export default SvgComponent;